/**
 * Stack-Auth-Client (Neon Auth = Stack Auth).
 *
 * Paket: @stackframe/react (React-SDK fuer Vite/CRA, nicht die Next.js-Variante @stackframe/stack).
 * Quelle: https://www.npmjs.com/package/@stackframe/react  /  https://docs.stack-auth.com
 *
 * OFFENER PUNKT (gegen echte Infra verifizieren): exakter SDK-Paketname/-Version und die
 * `urls`-Keys. Siehe README -> OFFENE PUNKTE.
 */
import { StackClientApp } from "@stackframe/react";

export const stackApp = new StackClientApp({
  projectId: import.meta.env.VITE_STACK_PROJECT_ID,
  publishableClientKey: import.meta.env.VITE_STACK_PUBLISHABLE_CLIENT_KEY,
  // "cookie" -> Tokens im Browser-Cookie (Standard fuer SPA ohne Next.js).
  tokenStore: "cookie",
  urls: {
    // Basis-Route, unter der <StackHandler> die Auth-Seiten rendert (siehe App.tsx).
    handler: "/handler",
    signIn: "/handler/sign-in",
    signUp: "/handler/sign-up",
    afterSignIn: "/",
    afterSignUp: "/",
    afterSignOut: "/handler/sign-in",
  },
});
